/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12C14 10.625 12.875 9.5 11.5 9.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.5 17C10.125 17 9 18.125 9 19.5C9 20.875 10.125 22 11.5 22C12.875 22 14 20.875 14 19.5C14 18.125 12.875 17 11.5 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7Z"
					fill="currentColor"
				/>
				<path
					d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12C14 10.625 12.875 9.5 11.5 9.5Z"
					fill="currentColor"
				/>
				<path
					d="M11.5 17C10.125 17 9 18.125 9 19.5C9 20.875 10.125 22 11.5 22C12.875 22 14 20.875 14 19.5C14 18.125 12.875 17 11.5 17Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12C14 10.625 12.875 9.5 11.5 9.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.5 17C10.125 17 9 18.125 9 19.5C9 20.875 10.125 22 11.5 22C12.875 22 14 20.875 14 19.5C14 18.125 12.875 17 11.5 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7Z"
				fill="currentColor"
			/>
			<path
				d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12C14 10.625 12.875 9.5 11.5 9.5Z"
				fill="currentColor"
			/>
			<path
				d="M9 19.5C9 18.125 10.125 17 11.5 17C12.875 17 14 18.125 14 19.5C14 20.875 12.875 22 11.5 22C10.125 22 9 20.875 9 19.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7ZM11.5 17C10.125 17 9 18.125 9 19.5C9 20.875 10.125 22 11.5 22C12.875 22 14 20.875 14 19.5C14 18.125 12.875 17 11.5 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12C14 10.625 12.875 9.5 11.5 9.5Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M11.5 17C10.125 17 9 18.125 9 19.5C9 20.875 10.125 22 11.5 22C12.875 22 14 20.875 14 19.5C14 18.125 12.875 17 11.5 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.5 9.5C10.125 9.5 9 10.625 9 12C9 13.375 10.125 14.5 11.5 14.5C12.875 14.5 14 13.375 14 12C14 10.625 12.875 9.5 11.5 9.5Z"
				fill="currentColor"
			/>
			<path
				d="M11.5 7C12.875 7 14 5.875 14 4.5C14 3.125 12.875 2 11.5 2C10.125 2 9 3.125 9 4.5C9 5.875 10.125 7 11.5 7Z"
				fill="currentColor"
			/>
			<path
				d="M11.5 17C10.125 17 9 18.125 9 19.5C9 20.875 10.125 22 11.5 22C12.875 22 14 20.875 14 19.5C14 18.125 12.875 17 11.5 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
